module.exports = __webpack_public_path__ + "static/img/terminalIllegal_pic01.46c8d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/terminalIllegal/terminalIllegal_pic01.png
// module id = 593
// module chunks = 1